<template>
  <v-btn-icon :title="$t(elConfigItem ? 'ELEMENT-DETAIL.HIDE_ON_PLANNING' : 'ELEMENT-DETAIL.SHOW_ON_PLANNING')" size="small" tabindex="-1"
              @click="elConfigItem = ! elConfigItem">
    <v-icon>far {{ elConfigItem ? 'fa-eye' : 'fa-eye-slash' }}</v-icon>
  </v-btn-icon>
</template>

<script>
  import useUiWorkingviewStore from '@/stores/ui/workingview';

  export default {
    props: {
      el: { type: Object, required: true },
      config: { type: String, required: true },
    },
    data() {
      return {
        uiWorkingviewStore: useUiWorkingviewStore(),
      };
    },
    computed: {
      elConfigItem: {
        get() {
          return this.el.getConfig(this.config);
        },
        set(newVal) {
          this.el.setConfig(this.config, newVal);
        },
      },
    },
  };
</script>
